import {ActionReducerMap} from '@ngrx/store';
import {InjectionToken, Provider} from '@angular/core';
import {CustomStoresState} from "../selectors/custom-store-finder.states";
import {StateUtils} from "@spartacus/core";
import {STORE_FINDER_DATA} from "../actions/custom-store-finder.actions";
import {customFindStoresReducer} from "./custom-store-finder.reducer";


export function getReducers(): ActionReducerMap<CustomStoresState> {
  return {
    findStores: StateUtils.loaderReducer(STORE_FINDER_DATA, customFindStoresReducer)
  };
}

export const reducerToken: InjectionToken<
  ActionReducerMap<CustomStoresState>
> = new InjectionToken<ActionReducerMap<CustomStoresState>>('CustomStoreFinderReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

